import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfigurationManagementService } from '../../../service/configuration-management.service';
import { LanguageManagementService } from '../../../service/language-management.service';
import { BusinessEnabledOption, BusinessWrapper, FocusInputType, KeyValues10, KeyValues30, KeyValues3, KeyValues5Sets, KeyValueSet, LocalService, NumericConfig, PageKey, ReceiptType, RelationShipRole, SellerInitialization, Status, TriggeredEvent, WorkingRangeType, TokenFormatType } from '../../../service/local.service';
import { SellerManagementService } from '../../../service/seller-management.service';
import { BillingManagementService } from 'src/service/billing-management.service';
import { GetFinancialYear, GetTokenDateFormat } from 'src/app/supporting/conversion';

@Component({
  selector: 'app-seller',
  templateUrl: './seller.component.html',
  styleUrls: ['./seller.component.scss']
})
export class SellerComponent implements OnInit {
  lstSectionConfigKeys: string[] = ["seller", "local_locations"]; BusinessEnabledOption = BusinessEnabledOption;
  businessId: string = ''; businessName: KeyValueSet; ctryCode = ''; userId = '';
  message: string = ''; isRedAlert: boolean = true;
  sellerInitializationWrapper: SellerInitialization;
  elementIds: any; htmlId: string = ''; RelationShipRole = RelationShipRole; isSellerLoading = false;

  isProductDetailPopupOpen = false; isNotConsiderTax = true; isInventoryEnabled: boolean = false; businessTaxes: KeyValues5Sets[] = [];
  isWorkingHoursPopupOpen = false;
  isOpenUserAuthentication = false; isOpenReceiptOptions = false;
  isAlphaNumericPostalCode = false; numericConfig: NumericConfig = {} as NumericConfig;
  selectedRangeWorkingHours: KeyValues10;
  isOpenBillingAdjustmentFormula: boolean = false;
  isOpenFontSettings: boolean = false;
  isReceiptIconConfig: boolean = false; isOpenConfirmationBox: boolean = false;
  financeYearRange: string = ''; sampleBillFormat: string = ''; sampleTokenFormat: string = ''; sampleTokenFormatInDb: string = '';
  tokenFormatTypes: KeyValueSet[] = [
    { key: TokenFormatType.YearMonthDay.toString(), value: 'Year Month Date' } as KeyValueSet,
    { key: TokenFormatType.DayMonthYear.toString(), value: 'Date Month Year' } as KeyValueSet,
  ];
  verificationPin: string;
  constructor(public localService: LocalService, private cdr: ChangeDetectorRef, private languageManagementService: LanguageManagementService, private sellerManagementService: SellerManagementService, private route: ActivatedRoute, private router: Router, private configurationManagementService: ConfigurationManagementService, private billingManagementService: BillingManagementService) {
    this.htmlId = this.localService.getRandomString(5);
    this.elementIds = {
      postal_code: 'seller_postal_code',
      state: 'local_location_state_',
      district: 'local_location_district_',
      constituency: 'local_location_constituency_',
      name: 'seller_name_' + this.htmlId,
      first_name: 'seller_name_' + this.htmlId + '_m',
      address: 'seller_address_' + this.htmlId,
      first_address: 'seller_address_' + this.htmlId + '_m',
      local_language: 'local_language',
      receipt_type: 'receipt_type',
      business_type: 'business_type',
      expected_business: 'expected_business',
      delivery_type: 'delivery_type',
      currency_symbol: 'currency_symbol_' + this.htmlId,
      token_start_nbr: 'token_start_nbr_' + this.htmlId,
      token_split_char: 'token_split_char_' + this.htmlId,
      token_prefix: 'token_prefix_' + this.htmlId,
      token_min_digits: 'token_min_digits_' + this.htmlId,
      token_date_split_char: 'token_date_split_char_' + this.htmlId,
      service_charge: 'service_charge_' + this.htmlId,
    };
  }

  ngOnInit(): void {
    this.onSetFinanceYear();
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.route.params.subscribe(routeParams => {
      this.ctryCode = routeParams.ctryCode;
      this.userId = routeParams.userId;
      this.businessId = routeParams.businessId;
      this.configurationManagementService.ensurePageActions(PageKey.Seller, this.businessId);
      this.localService.saveUrl();
      this.localService.setBasicParams(routeParams.ctryCode, routeParams.userId, routeParams.interactionType, routeParams.businessId);
      if (this.businessId == '0')
        this.businessId = '';
      this.onLoad();
    });
  }

  ngAfterViewChecked() {
    this.cdr.detectChanges();
  }

  onAfterAccessCheck() {
    if (!(this.sellerInitializationWrapper && this.sellerInitializationWrapper.business)) {
      this.onLoad();
    }
  }

  onLoad() {
    if (!this.businessId || this.businessId.length < 5 || this.localService.isUserHasBusinessRole(this.businessId, RelationShipRole.Admin)) {
      this.numericConfig.maxDigits = this.localService.getPostalCodeMaxDigitByCountryCode(this.localService.getLoginAsCountryCode());
      this.isAlphaNumericPostalCode = this.localService.getIsAlphaNumericPostalCodeByCountryCode(this.localService.getLoginAsCountryCode());
      this.isSellerLoading = true;
      this.sellerManagementService.getSellerInitialization(this.businessId).subscribe(result => {
        this.sellerInitializationWrapper = result;
        if (this.businessId == '') {
          this.sellerManagementService.getBusinessEnabledOptions('', true).subscribe(result => {
            this.sellerInitializationWrapper.business = {
              expectedBusinessTypes: [],
              deliveryTypes: [],
              contactNumbers: [],
              emails: [],
              notificationTypes: [],
              languageContentsName: null,
              languageContentsAddress: null,
              languageContentsDescription: null,
              localLocations: { v3: '', v2: '', v1: '' } as KeyValues3,
              content: {
                key: '', v1: '', v8: '', v2: '',
                v9: this.localService.loggedMember != undefined && this.localService.loggedMember != null ? this.localService.loggedMember.loggedMember.content.v8 : '',
                v11: '',
                v17: "0",
                v18: "1",
                v19: "/",
                v20: "",
                v21: "3",
                v22: TokenFormatType.YearMonthDay.toString()
              } as KeyValues30,
              businessEnabledOptions: result
            } as BusinessWrapper;
          });
        } else {
          this.setBusinessName();
        }
        this.sampleTokenFormatInDb = '';
        this.onFormatSampleBill();
        this.isSellerLoading = false;
      });
    }
  }

  onActiveInactiveStatus(strId: string) {
    //this.locationManagementService.activeInactiveStatus(strId, ActiveInactiveFor.Location).subscribe(result => {
    //  if (result == Status.Success) {
    //    const updatedItem = this.wrapper.contents.find(x => x.id == strId);
    //    updatedItem.content.isActive = !updatedItem.content.isActive;
    //  }
    //  
    //});
  }

  onEmptyLanguageContainerAdded(languageContents: any, index) {
    switch (index) {
      case 1: {
        this.sellerInitializationWrapper.business.languageContentsName = languageContents;
      } break;
      case 2: {
        this.sellerInitializationWrapper.business.languageContentsAddress = languageContents;
      } break;
      case 3: {
        this.sellerInitializationWrapper.business.languageContentsDescription = languageContents;
      } break;
    }
  }

  onValuesUpdated(values: any, index) {
    switch (index) {
      case 1: {
        this.sellerInitializationWrapper.business.contactNumbers = values;
      } break;
      case 2: {
        this.sellerInitializationWrapper.business.emails = values;
      } break;
    }
  }

  onSave() {
    this.sellerInitializationWrapper.business.supportings = [];
    this.sellerInitializationWrapper.supporting.forEach(x => {
      this.sellerInitializationWrapper.business.supportings.push({ key: x.key, value: x.v3 });
    });
    this.sellerInitializationWrapper.business.taxes = this.sellerInitializationWrapper.taxes;

    if (this.doCheck()) {
      this.sellerManagementService.saveBusiness(this.sellerInitializationWrapper.business).subscribe(result => {
        this.localService.showInformationByStatus(result.status);
        this.sampleTokenFormatInDb = '';
        this.onFormatSampleBill();
        switch (result.status) {
          case Status.Success: {
            this.localService.onRefreshBusiness();
            if (this.businessId == '' || this.businessId == '0') {
              this.businessId = result.id;
              this.configurationManagementService.ensureUserRolesForBusiness(this.businessId, true);
              this.onRoute(7);
            } else {
              this.onRoute(7);
            }
          } break;
        }
      });
    }
  }

  onLocationUpdated(e) {
    this.sellerInitializationWrapper.business.localLocations = e;
  }

  onClosesProductDetailPopup(e) {

  }

  onSelectOption(key: string | number) {
    this.sellerInitializationWrapper.business.businessEnabledOptions.forEach(x => {
      if (x.key.toString() == key.toString()) {
        x.isSelected = !x.isSelected;
      }
    });
  }

  onClosesWorkingHoursPopup(result) {
    if (result) {
      if (result.event == TriggeredEvent.Ok) {
        this.onSaveWorkingHours(result.data);
      }
    }
  }

  onRoute(index) {
    switch (index) {
      case 1: {
        this.isInventoryEnabled = this.sellerInitializationWrapper.business.businessEnabledOptions.filter(x => x.key == BusinessEnabledOption.HasInventory && x.isSelected).length > 0;
        this.isNotConsiderTax = this.sellerInitializationWrapper.business.businessEnabledOptions.filter(x => x.key == BusinessEnabledOption.ConsiderBaseAmountAsTaxInCludedAmount && x.isSelected).length > 0;
        this.businessTaxes = this.sellerInitializationWrapper.taxes;
        this.isProductDetailPopupOpen = true;
      } break;
      case 2: {
        this.isOpenUserAuthentication = true;
      } break;
      case 3: {
        this.sellerManagementService.getWorkingRange(this.businessId, WorkingRangeType.Business).subscribe(result1 => {
          this.selectedRangeWorkingHours = result1;
          this.isWorkingHoursPopupOpen = true;
        });
      } break;
      case 4: {
        this.router.navigate(['/business-payments', this.ctryCode, this.userId, 2, this.businessId]);
      } break;
      case 5: {
        this.router.navigate(['/billing', this.ctryCode, this.userId, 2, this.businessId, '0']);
      } break;
      case 6: {
        this.router.navigate(['/billings', this.ctryCode, this.userId, 2, this.businessId]);
      } break;
      case 7: {
        // if (this.sellerInitializationWrapper.business.notificationTypes.length > 0) {
        //   const modalRef = this.modalService.open(SmsSettingsComponent, { size: 'lg' });
        //   modalRef.componentInstance.businessId = this.businessId;
        //   modalRef.componentInstance.relationShipType = InteractionType.Business;
        //   modalRef.componentInstance.isShowActive = false;
        //   modalRef.componentInstance.notificationType = parseInt(this.sellerInitializationWrapper.business.notificationTypes[0]);
        // }
      } break;
      case 8: {
        this.router.navigate(['/seller', this.ctryCode, this.userId, 2, '0']);
      } break;
    }
  }

  onCloseUserAuthentication(isFromAnotherPopup: boolean, result?: any) {
    if (isFromAnotherPopup) {
      result = this.localService.dataWhileClosingPopupAndTriggerButton;
    }
    if (isFromAnotherPopup && result) {
      this.isOpenUserAuthentication = true;
    }
  }

  onCloseReceiptOptions(result?: any) {

  }

  onSaveWorkingHours(data) {
    this.sellerManagementService.saveWorkingHoursRange(data, this.businessId).subscribe(result => {
    });
  }

  setBusinessName() {
    let item = this.sellerInitializationWrapper.business.languageContentsName.filter(x => x.v3 != '').find(x => x.v1 == this.localService.selected.applicationLanguage);
    if (!item && this.sellerInitializationWrapper.business.languageContentsName.filter(x => x.v3 != '').length > 0) {
      item = this.sellerInitializationWrapper.business.languageContentsName.filter(x => x.v3 != '')[0];
    }
    if (item) {
      this.businessName = {
        key: item.v1, value: item.v3
      } as KeyValueSet;
    } else {
      this.businessName = {
        key: '', value: ''
      } as KeyValueSet;
    }
    this.onCheckReceiptType();
  }

  isFixReceiptType = false;
  onCheckReceiptType() {
    const receiptType = parseInt(this.sellerInitializationWrapper.business.content.v2);
    const fixedReceiptType = Object.keys(ReceiptType).find(k => ReceiptType[k as keyof typeof ReceiptType] === receiptType);
    this.isFixReceiptType = fixedReceiptType?.startsWith("Fix_");
  }

  doCheck() {
    let message = '';
    this.isRedAlert = true;
    let businessWrapper = this.sellerInitializationWrapper.business;
    businessWrapper.content.v9 = businessWrapper.content.v9.toString().trim();
    if (businessWrapper.content.v1.trim() == '') {
      message = this.localService.languageContent.seller.need_local_language;
      this.localService.onFocusNextInput(this.elementIds.local_language, FocusInputType.NgxDropDown);
    } /* else if (businessWrapper.localLocations.v3.trim() == '') {
      message = this.localService.languageContent.seller.need_state;
      this.localService.onFocusNextInput(this.elementIds.state, FocusInputType.NgxDropDown);
    } else if (businessWrapper.localLocations.v2.trim() == '') {
      message = this.localService.languageContent.seller.need_district;
      this.localService.onFocusNextInput(this.elementIds.district, FocusInputType.NgxDropDown);
    } else if (businessWrapper.localLocations.v1.trim() == '') {
      message = this.localService.languageContent.seller.need_constituency;
      this.localService.onFocusNextInput(this.elementIds.constituency, FocusInputType.NgxDropDown);
    } */ else if (businessWrapper.content.v9 == '') {
      message = this.localService.languageContent.seller.need_postal;
      this.localService.onFocusNextInput(this.elementIds.postal_code, FocusInputType.TextBox);
    } else if (this.numericConfig.maxDigits > 0 && businessWrapper.content.v9.length != this.numericConfig.maxDigits) {
      message = this.localService.languageContent.seller.need_valid_postalcode;
      this.localService.onFocusNextInput(this.elementIds.postal_code, FocusInputType.TextBox);
    } else if (!businessWrapper.languageContentsName || businessWrapper.languageContentsName.filter(x => x.v3.trim() != '').length == 0) {
      message = this.localService.languageContent.seller.need_name;
      this.localService.onFocusNextInput(this.elementIds.first_name, FocusInputType.TextBox);
    } else if (businessWrapper.content.v2.trim() == '') {
      message = this.localService.languageContent.seller.need_receipt_type;
      this.localService.onFocusNextInput(this.elementIds.receipt_type, FocusInputType.NgxDropDown);
    } else if (businessWrapper.content.v8.trim() == '') {
      message = this.localService.languageContent.seller.need_my_business_type;
      this.localService.onFocusNextInput(this.elementIds.business_type, FocusInputType.NgxDropDown);
    } else if (businessWrapper.content.v16.trim() == '') {
      message = this.localService.languageContent.seller.need_currency_symbol;
      this.localService.onFocusNextInput(this.elementIds.currency_symbol, FocusInputType.NgxDropDown);
    } else if (businessWrapper.expectedBusinessTypes.length == 0) {
      message = this.localService.languageContent.seller.need_expected_business;
      this.localService.onFocusNextInput(this.elementIds.expected_business, FocusInputType.NgxDropDown);
    } else if (businessWrapper.deliveryTypes.length == 0) {
      message = this.localService.languageContent.seller.need_delivery_type;
      this.localService.onFocusNextInput(this.elementIds.delivery_type, FocusInputType.NgxDropDown);
    } else if (!businessWrapper.languageContentsAddress || businessWrapper.languageContentsAddress.filter(x => x.v3.trim() != '').length == 0) {
      message = this.localService.languageContent.seller.need_address;
      this.localService.onFocusNextInput(this.elementIds.first_address, FocusInputType.TextBox);
    }
    this.message = message;
    if (this.message != '') {
      this.localService.showInformation(this.message, this.isRedAlert);
    }
    return message == '';
  }

  onAction(index: number, key?: string) {
    switch (index) {
      case 1: {
        //Receipt options
        this.isOpenReceiptOptions = true;
      } break;
      case 2: {
        //Remove receipt print cache
        this.localService.receiptPrintDatas = [];
        this.billingManagementService.removeReceiptPrintCache(this.businessId).subscribe(result => {
          this.localService.showInformationByStatus(result.status);
          if (result.status == Status.Success) {
            this.localService.receiptPrintDatas = [];
            this.localService.onTriggerClass('on_local_printer_changed');
          }
        });
      } break;
      case 3: {
        //Set billing adjustment formula
        this.isOpenBillingAdjustmentFormula = true;
      } break;
      case 4: {
        this.isOpenFontSettings = true;
      } break;
      case 5: {
        this.isReceiptIconConfig = true;
      } break;
    }
  }

  onSetFinanceYear(date = new Date()) {
    const year = date.getFullYear();
    const month = date.getMonth() + 1; // JS months: 0-11

    let startYear, endYear;

    // Before or on March => current FY ends current year, starts previous year
    if (month <= 3) {
      startYear = year - 1;
      endYear = year;
    } else {
      startYear = year;
      endYear = year + 1;
    }

    this.financeYearRange = `01-Apr-${startYear} to 31-Mar-${endYear}`;
  }

  confirmationType = 0;
  onConfirmed(result: any) {
    this.isOpenConfirmationBox = false;
    if (result && result.event == TriggeredEvent.Ok) {
      switch (this.confirmationType) {
        case 1: {
          this.onReformatInvoiceNumber(true);
        } break;
        case 2: {
          this.onResetAcceptanceNumber(true);
        } break;
      }
    }
  }

  onReformatInvoiceNumber(isConfirmed = false) {
    if (isConfirmed) {
      this.billingManagementService.reformatInvoiceNumber(this.businessId).subscribe(result => {
        this.localService.showInformationByStatus(result.status);
      });
    } else {
      this.confirmationType = 1;
      this.isOpenConfirmationBox = true;
    }
  }

  onResetAcceptanceNumber(isConfirmed = false) {
    if (isConfirmed) {
      this.sellerManagementService.resetCurrentAcceptanceNumber(this.businessId).subscribe(result => {
        this.localService.showInformationByStatus(result.status);
        if (result.status == Status.Success) {
          this.sellerInitializationWrapper.business.content.v23 = '0';
        }
      });
    } else {
      this.confirmationType = 2;
      this.isOpenConfirmationBox = true;
    }
  }

  onFormatSampleBill() {
    let rtn = '';

    const splitCharacter = this.sellerInitializationWrapper.business.content.v19 && this.sellerInitializationWrapper.business.content.v19.trim().length > 0 ? this.sellerInitializationWrapper.business.content.v19.trim() : '';

    const splitCharacterOfToken = this.sellerInitializationWrapper.business.content.v24 && this.sellerInitializationWrapper.business.content.v24.trim().length > 0 ? this.sellerInitializationWrapper.business.content.v24.trim() : '';

    const tokenPrefix = this.sellerInitializationWrapper.business.content.v20 && this.sellerInitializationWrapper.business.content.v20.trim().length > 0 ? this.sellerInitializationWrapper.business.content.v20.trim() : '';

    const minimumDigits = parseInt(this.sellerInitializationWrapper.business.content.v21 && this.sellerInitializationWrapper.business.content.v21.toString().trim().length > 0 ? this.sellerInitializationWrapper.business.content.v21.toString().trim() : '0');

    const tokenStartNumber = this.sellerInitializationWrapper.business.content.v18 && this.sellerInitializationWrapper.business.content.v18.toString().trim().length > 0 ? this.sellerInitializationWrapper.business.content.v18.toString().trim() : '101';

    if (tokenPrefix.length > 0) {
      rtn += tokenPrefix;
    }

    const financialYear = GetFinancialYear(new Date(), this.localService.selected.countryCode);
    rtn += financialYear.toString().slice(-2);
    rtn += splitCharacter;
    rtn += '1'.padStart(minimumDigits, '0');

    const dateNow = this.localService.getDeviceDate();
    const todayTokenDate = GetTokenDateFormat(parseInt(this.sellerInitializationWrapper.business.content.v22), dateNow, this.sellerInitializationWrapper.business.content.v24);

    this.sampleTokenFormat = [todayTokenDate, '-', tokenStartNumber].join('');

    this.sampleBillFormat = rtn;

    if (this.sampleTokenFormatInDb.length == 0) {
      this.sampleTokenFormatInDb = rtn;
    }
  }

  onGeneratePin() {
    this.sellerManagementService.generateOtpForBusinessIdentificationCode(this.businessId).subscribe(result => {
      this.localService.showInformationByStatus(result.status);
      if (result.status == Status.Success) {
        this.verificationPin = result.value;
      }
    });
  }
}
